import { PaymentStatus } from "../../../apps/server/api/src/features/merchant/payment-intent/type";
import * as Internal from "./internal/index";
export function createCrablrAdmin(options) {
    const internal = {
        trpc: Internal.TrpcClient.createTrpc(options),
    };
    return {
        createPaymentIntent: internal.trpc.createPaymentIntent.mutate,
        getPaymentIntent: internal.trpc.getPaymentIntent.query,
        createCheckoutSession: internal.trpc.createCheckoutSession.mutate,
        internal,
    };
}
export function createWebhook(options) {
    if (!options.webhookSecret.startsWith("whs_")) {
        throw new Error("Invalid webhook secret. It must starts with whs_");
    }
    return {
        assertSignature: Internal.Webhook.assertSignature(options.webhookSecret),
    };
}
export { PaymentStatus };
export const Webhook = Internal.Webhook;
export { Internal };
